import { i18n } from "@/locales";
import "@mdi/font/css/materialdesignicons.css";
import { useI18n } from "vue-i18n";
import { createVuetify } from "vuetify";
import { VCard, VTooltip, VBtn, VDialog, VSwitch } from "vuetify/components";
import { aliases, mdi } from "vuetify/iconsets/mdi";
import { createVueI18nAdapter } from "vuetify/locale/adapters/vue-i18n";
import "vuetify/styles";

export default createVuetify({
  aliases: {
    VBtnPrimary: VBtn,
    VBtnSecondary: VBtn,
    VDialogMain: VDialog,
    VCardMain: VCard,
    VTooltipTop: VTooltip,
  },
  locale: {
    adapter: createVueI18nAdapter({ i18n, useI18n }),
  },
  theme: {
    defaultTheme: "lightgreen",
    themes: {
      light: {
        dark: false,
        colors: {
          background: "#CCC6C8",
          surface: "#FFFFFF",
          headers: "#F4F4F4",
          "surface-variant": "#424242",
          "on-surface-variant": "#EEEEEE",
          primary: "#4CAF50",
          "primary-darken-1": "#43A047",
          secondary: "#03A9F4",
          "secondary-darken-1": "#039BE5",
          error: "#B00020",
          info: "#2196F3",
          success: "#4CAF50",
          warning: "#FB8C00",
        },
        variables: {
          "border-color": "#000000",
          "border-opacity": 0.12,
          "high-emphasis-opacity": 0.87,
          "medium-emphasis-opacity": 0.6,
          "disabled-opacity": 0.38,
          "idle-opacity": 0.04,
          "hover-opacity": 0.04,
          "focus-opacity": 0.12,
          "selected-opacity": 0.08,
          "activated-opacity": 0.12,
          "pressed-opacity": 0.12,
          "dragged-opacity": 0.08,
          "theme-kbd": "#212529",
          "theme-on-kbd": "#FFFFFF",
          "theme-code": "#F5F5F5",
          "theme-on-code": "#000000",
        },
      },
      dark: {
        dark: true,
        colors: {
          headers: "#1f1f1f",
          "background-card": "#212121",
        },
      },
      lightgreen: {
        dark: false,
        colors: {
          background: "#3d5c6b",
          "background-card": "#384767",
          surface: "#fff",
          headers: "#fff",
          "surface-light": "#252d3f",
          "primary-darken-1": "#3700B3",
          primary: "#7BB601",
          secondary: "#03DAC6",
          "secondary-darken-1": "#018786",
          error: "#ff3358",
          info: "#2196F3",
          success: "#7BB601",
          warning: "#FB8C00",
        },
        variables: {
          "activated-opacity": "0.075",
          "theme-on-headers": "#3d5c6b",
          "theme-surface-variant": "#8ba6b3",
          "theme-on-surface-variant": "#fff",
          "theme-surface-light": "#3d5c6b",
        },
      },
    },
  },

  defaults: {
    VBtn: {
      color: "primary",
    },
    VBtnPrimary: {
      color: "primary",
      variant: "elevated",
    },
    VSwitch: {
      color: "primary",
    },
    VTextField: {
      variant: "outlined",
    },
    VTextarea: {
      variant: "outlined",
    },
    VSelect: {
      variant: "outlined",
    },
    VDateInput: {
      variant: "outlined",
      hideActions: true,
      prependIcon: "",
      prependInnerIcon: "mdi-calendar",
    },
    VBtnSecondary: {
      color: "secondary",
    },
    VSheet: {
      elevation: 4,
    },
    VDialog: {
      transition: "dialog-bottom-transition",
    },
    VDialogMain: {
      fullscreen: true,
      transition: "scroll-y-reverse-transition",
      rounded: 0,
    },
    VCard: {
      rounded: "xl",
    },
    VCardMain: {
      rounded: 0,
      VToolbar: {
        height: 56,
        class: "tw:!mb-10",
      },
    },
    VTooltip: {
      activator: "parent",
      contentClass: "tooltip-arrow",
    },
  },

  icons: {
    defaultSet: "mdi",
    aliases,
    sets: {
      mdi,
    },
  },
});
